import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IAccount } from '../models/IAccount.model';
import { IUserAvatar } from '../models/IUser.model';
import { IWsResult } from '../models/ws_result.model';
import { ErrorHandlerService } from './shared/error-handler.service';
import { Helpers } from '../models/helpers';

@Injectable({
  providedIn: 'root',
})

export class AccountsService {
  url: string = environment.urlServer;
  facAvatar: IUserAvatar;

  constructor(
    private http: HttpClient,
    private errorHandlerServ: ErrorHandlerService
  ) { }

  // getAccount(id) removed in v2.3.0 — was used only by the deleted
  // GestioneAccountDettagli + Edit legacy components. The single-page
  // restyle keeps the whole account list in memory and opens modals
  // from the in-memory record, no extra HTTP needed.

  getAccounts(searchString: string = ''): Observable<IAccount[]> {
    return this.http
      .get<IWsResult>(`${this.url}/get_accounts/`, {
        headers: { search: `${searchString}` },
      })
      .pipe(
        catchError(
          this.errorHandlerServ.handleError<IWsResult>('getAccounts')
        )
      )
      .pipe(
        map((result: IWsResult) => result.data)
      );
  }

  // searchAccounts() removed in v2.3.0 — was a dead alias of
  // getAccounts() with the same `search` header. The single-page
  // restyle does search client-side, no extra round-trip.

  // saveAvatar() removed in v2.3.0 — was used only by the nested
  // UploadComponent under the deleted gestione-account-dettagli.
  // The endpoint `${url}/put_avatar` still exists backend-side; when
  // we re-add avatar upload in Phase 2, restore this method.

  saveAccount(user: IAccount) {
    return this.http
      .post<IWsResult>(`${this.url}/save_account/`, user)
      .pipe(
        catchError(
          this.errorHandlerServ.handleError<IWsResult>('getAccount')
        )
      );
  }

  deleteAccount(account_id: string) {
    return this.http
      .post<IWsResult>(`${this.url}/del_account`, { account_id })
      .pipe(
        catchError(
          this.errorHandlerServ.handleError<IWsResult>('deleteAccount')
        )
      );
  }



}
